import { render, staticRenderFns } from "./CustomerFormPage.vue?vue&type=template&id=3738addc"
import script from "./CustomerFormPage.vue?vue&type=script&lang=js"
export * from "./CustomerFormPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports